import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 20px;
`;

export const ContainerPreview = styled.div`
  position: absolute;
  margin-top: 33px;
  width: 336px;
  height: 705px;
  background-color: #ffffff;
`;

export const MockupPhone = styled.img`
  width: 370px;
  z-index: 2;
`;
